export const notificationMixin = {
  methods: {
    actionSuccess (value) {
      this.$buefy.toast.open({
        message: value,
        type: 'is-success'
      })
    },
    actionFailure (value) {
      this.$buefy.toast.open({
        message: value,
        type: 'is-danger'
      })
    },
    emailSent () {
      this.$buefy.dialog.alert({
        title: 'Email Sent !',
        message: 'Thank you for your message, we will come back to you soon (⌒ω⌒)',
        confirmText: 'Close',
        type: 'is-success',
        onConfirm: () => this.$router.push('/')
      })
    },
    alertError () {
      this.$buefy.dialog.alert({
        title: 'Error',
        message: 'Something went wrong, please retry later.<br/>If the problem happens again, you can contact us at <b>contact@costuto.com</b>.',
        type: 'is-danger',
        hasIcon: true,
        icon: 'alert-octagon',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    cancelUpdate () {
      this.$buefy.dialog.confirm({
        title: 'Cancel Update',
        message: 'Are you sure you want to cancel your modifications?<br/> You will definitively lose your changes.',
        type: 'is-warning',
        hasIcon: true,
        confirmText: 'Yes',
        cancelText: 'Cancel',
        onConfirm: () => this.$parent.close()
      })
    }
  }
}
